module.exports = "img/button-text-bold.64994d2.svg";